var _clipPath, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAkamai = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "akamai_svg__akamai-clipPath-0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z"
}))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "akamai_svg__akamai-mask-0",
  width: 269,
  height: 349,
  x: -221,
  y: -8,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-220.525 340.003H47.75V-7.177h-268.275z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#akamai_svg__akamai-clipPath-0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#09c",
  d: "M6.621 22.229C3.935 21.413 1.983 18.934 1.983 16c0-2.964 1.994-5.464 4.72-6.26.28-.082.207-.258-.134-.258C2.944 9.482 0 12.406 0 16c0 3.595 2.944 6.518 6.57 6.518.34 0 .36-.196.051-.29"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#09c",
  d: "M3.233 17.518a5 5 0 0 1-.031-.527 5.17 5.17 0 0 1 5.175-5.174c2.706 0 3.512 1.208 3.615 1.125.114-.082-.981-2.479-4.152-2.479a5.17 5.17 0 0 0-4.824 7.045c.093.248.238.248.217.01"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#09c",
  d: "M5.403 13.79c1.343-.59 3.037-.61 4.7-.021 1.115.392 1.766.95 1.818.92.093-.042-.651-1.21-1.984-1.716a4.73 4.73 0 0 0-4.606.703c-.145.114-.093.186.072.114"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#f93"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32 16.227a.68.68 0 1 1-.682-.682c.383 0 .682.3.682.682M9.813 20.039l.083.909h1.436l-.486-5.278H8.708l-2.706 5.278h1.467l.454-.91zm-.072-1.023H8.43l1.126-2.282h.01zM13.325 18.644h.217l1.022-1.394h1.333l-1.415 1.777.868 1.921h-1.416l-.568-1.498h-.207l-.32 1.498h-1.208l1.115-5.278h1.209z"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#akamai_svg__akamai-mask-0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.788 20.948h1.208l.486-2.304c.268-1.27-.217-1.425-1.457-1.425-.867 0-1.704-.01-1.941 1.136h1.208c.072-.33.279-.402.579-.402.526 0 .506.216.433.557l-.124.589h-.051c-.042-.424-.579-.413-.92-.413-.877 0-1.394.279-1.58 1.167-.196.94.248 1.147 1.095 1.147.423 0 .992-.083 1.188-.59h.041zm-.341-1.529c.393 0 .65.03.589.34-.083.383-.248.455-.755.455-.185 0-.526 0-.444-.402.073-.342.31-.393.61-.393M21.444 17.25l-.114.516h.052c.238-.434.723-.557 1.136-.557.517 0 1.033.093.96.722h.053c.175-.527.712-.722 1.177-.722.857 0 1.22.35 1.033 1.208l-.537 2.53h-1.209l.455-2.138c.062-.382.124-.671-.341-.671-.475 0-.63.31-.713.713l-.444 2.097h-1.209l.476-2.242c.062-.34.082-.568-.341-.568-.496 0-.651.269-.744.713l-.444 2.097h-1.209l.785-3.698zM27.983 20.948h1.208l.496-2.304c.269-1.27-.217-1.425-1.456-1.425-.868 0-1.705-.01-1.942 1.136h1.208c.072-.33.28-.402.579-.402.526 0 .506.216.433.557l-.124.589h-.051c-.041-.424-.578-.413-.92-.413-.878 0-1.394.279-1.58 1.167-.196.94.248 1.147 1.095 1.147.424 0 .992-.083 1.188-.59h.041zm-.331-1.529c.392 0 .65.03.589.34-.083.383-.248.455-.754.455-.186 0-.527 0-.444-.402.072-.342.31-.393.609-.393"
})), /*#__PURE__*/React.createElement("path", {
  d: "M30.947 20.948h-1.209l.775-3.698h1.219z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAkamai);
export default ForwardRef;